import { defineStore } from 'pinia';
import axios from 'axios';

// Payment Methods admin store (Feature 4).
export const usePaymentMethodStore = defineStore('paymentMethods', {
    state: () => ({
        methods: [],
        loading: false,
        saving: false,
    }),

    actions: {
        async fetchMethods() {
            this.loading = true;
            try {
                const { data } = await axios.get('/admin/payment-methods');
                this.methods = data.data ?? [];
            } finally {
                this.loading = false;
            }
        },

        // Fetch a single method for the edit page (reuses the list; no dedicated
        // backend endpoint needed since the list is small).
        async fetchMethod(id) {
            if (!this.methods.length) await this.fetchMethods();
            return this.methods.find(m => String(m.id) === String(id)) ?? null;
        },

        // payload is a FormData instance (image / qr_image uploads).
        async createMethod(payload) {
            this.saving = true;
            try {
                const { data } = await axios.post('/admin/payment-methods', payload);
                this.methods.push(data.data);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async updateMethod(id, payload) {
            this.saving = true;
            try {
                const { data } = await axios.post(`/admin/payment-methods/${id}`, payload);
                this.replaceLocal(data.data);
                return data.data;
            } finally {
                this.saving = false;
            }
        },

        async toggle(id) {
            const { data } = await axios.patch(`/admin/payment-methods/${id}/toggle`);
            this.replaceLocal(data.data);
            return data.data;
        },

        async deleteMethod(id) {
            await axios.delete(`/admin/payment-methods/${id}`);
            this.methods = this.methods.filter(m => m.id !== id);
        },

        replaceLocal(method) {
            const idx = this.methods.findIndex(m => m.id === method.id);
            if (idx !== -1) this.methods[idx] = method;
        },
    },
});
